define(
  'pageSizeFilterHandler',[
    'builderShowcaseObserver',
    'event',
    'trackerSearchPagination'
  ],
  (builderShowcaseObserver) => {
    'use strict';

    function PageSizeFilterInitHandler() {
    }

    /**
    * @private
    * onSortByChanged: triggers the on change on the sorting options.
    *
    */
    function onPageSizeChanged(data) {
      const pageSizeSelect = document.querySelector('[data-component="page-size-options"]');
      const selectedOption = pageSizeSelect[pageSizeSelect.selectedIndex];
      let pageSize = data.target.value;
      if (pageSize === null) {
        pageSize = selectedOption.value;
      }

      const updatedSearchParams = {
        PageSize: Number(pageSize)
      };

      builderShowcaseObserver.setParameters(updatedSearchParams);
      builderShowcaseObserver.commit();
      const state = builderShowcaseObserver.getState();
      state.data.ReviewSearchParams.PageSize = Number(pageSize);
      state.filterType = 'pageSize';
      const pageUrl = document.querySelector('[data-page-number="1"]').href;
      window.history.pushState({}, null, pageUrl);
      builderShowcaseObserver.OnPageSizeChanged(state);
      window.NewHomeSource.TrackerSearchPagination.pageSizeSelectionTracker(pageSize);
    }

    /**
    * @private
    * SetListenersPageSize: set listeners for sort by select.
    *
    */
    function SetListenersPageSize() {
      const pageSizeList = document.querySelector('[data-component="page-size-options"]');
      pageSizeList.addEventListener('change', onPageSizeChanged);
    }

    const events = {
      onPageSizeChanged: {
        callbacks: [onPageSizeChanged],
        elements: '[data-component="page-size-options"]',
        events: ['change'],
      },
    };
    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    PageSizeFilterInitHandler.update = function SetListeners() {
      SetListenersPageSize();
    };

    SetListenersPageSize();
    window.NewHomeSource.Event(events);
    builderShowcaseObserver.subscribe('onReviewsSectionLoaded', PageSizeFilterInitHandler);
  }

);

